<div class="resume-user">
  <div class="resume-info">
    <img src="assets/images/{{data.logo}}" alt=""/>
    <h6 class="title">{{data.name}}</h6>
    <span class="text-primary">{{data.designation}}</span>
  </div>
  <a routerLink="/portfolio-{{data.profile}}" class="site-button">Check portfolio</a>
</div>